import { motion } from 'framer-motion'
import { ArrowUpRight, FileText } from 'lucide-react'
import { Link } from 'react-router-dom'
import SectionHeader from './SectionHeader'
import { publications } from '../data/publications'

const Publications = () => {
  return (
    <section id="publications" className="section-shell py-20 md:py-24">
      <SectionHeader
        centered
        kicker="Writing"
        title="Research notes, technical writing, and works in progress."
        text="A space for project writeups, technical articles, book drafts, and research-oriented notes connected to AI, HCI, education, games, and software systems."
      />

      <div className="mt-12 grid gap-5 lg:grid-cols-3">
        {publications.map((item, index) => (
          <motion.article
            key={item.slug}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.45, delay: index * 0.06 }}
            className="card flex flex-col p-6 transition hover:-translate-y-1 hover:border-academic-blue"
          >
            <div className="flex items-center justify-between gap-4">
              <span className="rounded-2xl bg-academic-soft p-3 text-academic-blue">
                <FileText size={21} />
              </span>

              <span className="rounded-full border border-academic-line px-3 py-1 text-xs font-semibold text-academic-muted">
                {item.status}
              </span>
            </div>

            <p className="mt-6 text-sm font-semibold text-academic-blue">
              {item.type}
            </p>

            <h3 className="mt-2 text-xl font-semibold leading-7 text-academic-text">
              {item.title}
            </h3>

            <p className="mt-4 flex-1 leading-7 text-academic-muted">
              {item.abstract}
            </p>

            <Link
              to={`/publications/${item.slug}`}
              className="mt-6 inline-flex items-center text-sm font-semibold text-academic-blue"
            >
              Read note <ArrowUpRight className="ml-2" size={16} />
            </Link>
          </motion.article>
        ))}
      </div>
    </section>
  )
}

export default Publications